import React from "react";
import ContentLoader from "react-content-loader";
import { fakeSettings } from "@/constants/constants";

const FakeProviderActivation = ({ withContainer = true }) => {
  return (
    <div className={withContainer ? "container" : ""}>
      <div className="fake-provider-activation">
        <ContentLoader
          height="100vh"
          width="100%"
          viewBox="0 0 100% 100vh"
          {...fakeSettings}
        >
          <rect x="0" y="0" rx="4" ry="4" width="48%" height="300" />
          <rect x="52%" y="0" rx="4" ry="4" width="48%" height="300" />
          <rect x="0" y="320" rx="4" ry="4" width="100%" height="400" />
        </ContentLoader>
      </div>
    </div>
  );
};

export default FakeProviderActivation;